import React from "react";
import { connect } from "react-redux";
import history from "../../auth/history";
import { v4 as uuidv4 } from 'uuid';
import { store } from '../../redux/store';
import axios from "axios";
import { Link } from "react-router-dom";
import swal from 'sweetalert';
import { CSVLink } from "react-csv";
import tokenErrorHandler from "../tokenErrorHandler";
import { selectedConsumerList, setBatch, setBillListConsumers, setBillListEndIndex, setBillListKeys, setBillListStartIndex, setBillListTotalAmount, setSelectedAmount } from "../../redux/misc-data/misc-data.action";
const httpClient = axios.create();
class BillListTotalComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            len: 0,
            selectedConsumers: [],
            selectedAmount: 0,
            statusList: [
                { value: "Select", label: "Select" },
                { value: "no_due", label: "No Due" },
                { value: "payment_due", label: "Payment Due" },
                { label: "Consumer created", value: "INITIATED" },
                { label: "No billfetch needed", value: "NO_FETCH_REQUIRED" },
                { label: "No due date", value: "NO_DUE_DATE_FOUND" },
                { label: "Billfetch success", value: "BILL_FETCH_SUCCESS" },
                { label: "Billfetch Failed", value: "BILL_FETCH_FAILED" },
                { label: "Manual BillPay", value: "MANUAL_BILLPAY_ENABLED" },
                // { label: "BillPay Pending", value: "BILL_PAY_PENDING" },
                { label: "BillPay Failed", value: "BILL_PAY_FAILED" },
                // { label: "BillPay Success", value: "BILL_PAY_SUCCESS" },
                // { label: "BillPay Processing", value: "BILL_PAY_PROCESSING" },
                // { label: "Order Created", value: "CREATE_ORDER_SUCCESS" },
                { label: "Order Failed", value: "CREATE_ORDER_FAILED" }

            ],
            due: "",
            loading: '',
            noFetchBillers: [],
            showFirstModal: false,
            consumerNoVal: '',
            searchOn: false,
            noFetchMap: new Map()
        }
    }
    billMap = new Map();


    pay = (event) => {
        event.preventDefault();
        this.setState({
            payErr: '',
            noFetchBillers: [],
            showFirstModal: false
        })
        var noFetchConsumers = [];
        var allStsatuses = '';
        var noFetchMap = new Map();

        if (this.state.selectedConsumers.length > 0) {
            store.dispatch(selectedConsumerList(this.state.selectedConsumers));
            store.dispatch(setSelectedAmount(this.state.selectedAmount));


            this.state.selectedConsumers.map(consumer => {
                allStsatuses = allStsatuses + consumer.fetchRequired;
            })

            this.state.selectedConsumers.map(consumer => {
                if (consumer.fetchRequired == false &&
                    consumer.lastKnownStatus != "BILL_PAY_PENDING" &&
                    consumer.lastKnownStatus != "BILL_PAY_PROCESSING" &&
                    consumer.lastKnownStatus != "CREATE_ORDER_SUCCESS") {

                    if (consumer.currentBillPayAmount != undefined &&
                        consumer.currentBillPayAmount != null &&
                        consumer.currentBillPayAmount != "") {
                        noFetchMap.set(consumer.id, consumer.currentBillPayAmount);
                    } else {
                        noFetchMap.set(consumer.id, 0);
                    }

                    noFetchConsumers.push(consumer);
                }
                if (consumer.fetchRequired == true &&
                    consumer.lastKnownStatus == "BILL_FETCH_FAILED") {
                    if (consumer.currentBillPayAmount != undefined &&
                        consumer.currentBillPayAmount != null &&
                        consumer.currentBillPayAmount != "") {
                        noFetchMap.set(consumer.id, consumer.currentBillPayAmount);
                    } else {
                        noFetchMap.set(consumer.id, 0);
                    }
                    noFetchConsumers.push(consumer);

                }

            })

            if (noFetchConsumers.length > 0) {
                setTimeout(() => {
                    this.setState({
                        noFetchBillers: noFetchConsumers,
                        noFetchMap: noFetchMap,
                        showFirstModal: true
                    })
                }, 200);
                var modalPrint = document.getElementById('modalPrint');
                modalPrint.click();
            } else {
                if (this.state.selectedAmount > 0 &&
                    allStsatuses.includes("false") == false) {
                    if (this.state.selectedAmount == 0) {

                    } else {
                        if (this.state.selectedAmount <= this.props.retailerBalanceValue) {
                            setTimeout(() => {
                                // var goTopayment = document.getElementById('goTopayment');

                                // if (goTopayment != null) {
                                //     goTopayment.click();
                                // } else {
                                //     history.push('/payment');
                                //     history.go();
                                // }
                                history.push('/payment');
                                history.go();
                            }, 400);
                        } else {
                            this.setState({
                                payErr: "Balance is lower than selected amount"
                            })

                            swal({
                                title: "Unable to proceed",
                                text: 'Balance is lower than selected amount',
                                icon: "error",
                                button: true,
                                dangerMode: true,
                            }).then(() => {
                                this.loadBills("");
                                // history.push('/bill-list');
                                // history.go();
                            });
                        }
                    }

                }
            }
        } else {
            alert("No biller selected");
        }
    }

    payAll = (event) => {
        event.preventDefault();
        var consumerList = [];
        var cnsmerList = [];
        var totalAmount = 0;
        this.setState({
            payErr: '',
            noFetchBillers: [],
            showFirstModal: false,
            selectedConsumers: []
        })
        var noFetchConsumers = [];
        var noFetchMap = new Map();
        var allStsatuses = '';
        if (this.props.billListConsumers != undefined &&
            this.props.billListConsumers != null &&
            this.props.billListConsumers.length > 0) {
            this.props.billListConsumers.map(consumer => {
                allStsatuses = allStsatuses + consumer.fetchRequired;
            })
        }



        if (this.props.billListConsumers != undefined &&
            this.props.billListConsumers != null &&
            this.props.billListConsumers.length > 0) {
            this.props.billListConsumers.map(consumer => {
                if (consumer.lastKnownStatus == "BILL_FETCH_SUCCESS"
                    || consumer.lastKnownStatus == "NO_FETCH_REQUIRED"
                    || consumer.lastKnownStatus == "CREATE_ORDER_FAILED"
                    || consumer.lastKnownStatus == "BILL_PAY_FAILED") {

                    if (consumer.fetchRequired == false ||
                        (consumer.fetchRequired == true &&
                            consumer.currentBillPayAmount != undefined &&
                            consumer.currentBillPayAmount != null &&
                            consumer.currentBillPayAmount != "" &&
                            consumer.currentBillPayAmount > 0)) {
                        consumerList.push(consumer);
                        store.dispatch(selectedConsumerList(consumerList));
                    }


                    if (consumer.fetchRequired == false &&
                        consumer.lastKnownStatus != "BILL_PAY_PENDING" &&
                        consumer.lastKnownStatus != "BILL_PAY_PROCESSING" &&
                        consumer.lastKnownStatus != "CREATE_ORDER_SUCCESS") {
                        if (consumer.currentBillPayAmount != undefined &&
                            consumer.currentBillPayAmount != null &&
                            consumer.currentBillPayAmount != "") {
                            noFetchMap.set(consumer.id, consumer.currentBillPayAmount);
                        } else {
                            noFetchMap.set(consumer.id, 0);
                        }

                        noFetchConsumers.push(consumer);
                    }



                    if (noFetchConsumers.length > 0) {

                        setTimeout(() => {
                            this.setState({
                                noFetchBillers: noFetchConsumers,
                                noFetchMap: noFetchMap,
                                showFirstModal: true
                            })

                        }, 200);
                        var modalPrint = document.getElementById('modalPrint');
                        modalPrint.click();

                    } else {

                        if (consumer.currentBillPayAmount != undefined &&
                            consumer.currentBillPayAmount != null &&
                            consumer.currentBillPayAmount > 0
                        ) {
                            totalAmount = totalAmount + consumer.currentBillPayAmount;
                            store.dispatch(setSelectedAmount(totalAmount));
                        }

                        setTimeout(() => {
                            if (allStsatuses.includes(false) == false) {

                                if (totalAmount == 0) {
                                } else {
                                    if (totalAmount <= this.props.retailerBalanceValue) {
                                        this.proceed3(totalAmount, consumerList);
                                    } else {

                                        this.setState({
                                            payErr: "Balance is lower than selected amount"
                                        })
                                        swal({
                                            title: "Unable to proceed",
                                            text: 'Balance is lower than selected amount',
                                            icon: "error",
                                            button: true,
                                            dangerMode: true,
                                        }).then(() => {

                                            this.loadBills("");
                                            // history.push('/bill-list');
                                            // history.go();

                                        });

                                    }
                                }
                            }
                        }, 600);


                    }
                }
            })
        } else {
            alert("No biller selected")
        }

    }



    loadBills(due) {
        store.dispatch(selectedConsumerList([]));
        store.dispatch(setBillListConsumers([]));
        store.dispatch(setBillListKeys([]));
        store.dispatch(setBillListTotalAmount(0));
        var totalActives = 0;
        var totalInactives = 0;

        this.setState({
            showFirstModal: false,
            loading: 'loading',
            searchOn: false
        })


        var url = '/api/v1/billpay/corp/consumer/get-list/';
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo,
            'role': this.props.clientRole
        }
        var value = (this.props.startDate != '' &&
            this.props.startDate != undefined &&
            this.props.startDate != null) ?
            '/' + this.props.startDate
            : '/all';

        var value1 = (this.props.endDate != '' &&
            this.props.endDate != undefined &&
            this.props.endDate != null) ?
            '/' + this.props.endDate
            : '/all'

        httpClient.get(url + this.props.agentInfo +
            value + value1,
            { headers }
        ).then((response) => {

            this.setState({
                searchOn: true
            })
            var list = [];
            var consumerList = [];
            var totalAmount = 0;

            if (response.data != null &&
                response.data != undefined &&
                response.data != "") {
                response.data.reverse().map(res => {
                    if (due != "") {
                        if (due == "no_due") {
                            if (res.lastBillFetch != null) {
                                if (res.lastKnownStatus.includes("BILL_PAY_SUCCESS")) {

                                    if (!consumerList.includes(res)) {
                                        if (res.optional != null) {
                                            const map = new Map(Object.entries(res.optional));
                                            var mapKeys = [...map.keys()];
                                            mapKeys.map(key => {
                                                var optionMap = {
                                                    key: key,
                                                    value: map.get(key),
                                                    id: res.id
                                                }
                                                list.push(optionMap)
                                                store.dispatch(setBillListKeys(list));
                                            })
                                        }


                                        if (res.currentBillPayAmount != undefined &&
                                            res.currentBillPayAmount > 0
                                        ) {
                                            totalAmount = totalAmount + res.currentBillPayAmount;
                                            setTimeout(() => {
                                                store.dispatch(setBillListTotalAmount(totalAmount));
                                            }, 300);

                                        }

                                       
                                        consumerList.push(res);
                                        setTimeout(() => {
                                            store.dispatch(setBillListConsumers(consumerList));
                                            store.dispatch(setBillListStartIndex(0))
                                            store.dispatch(setBillListEndIndex(5))
                                        }, 300);

                                    }

                                }
                            }
                        }
                        else if (due == "payment_due") {
                            if (res.lastBillFetch != null) {
                                if (res.lastKnownStatus.includes("BILL_FETCH_SUCCESS") ||
                                    res.lastKnownStatus.includes("CREATE_ORDER_SUCCESS") ||
                                    res.lastKnownStatus.includes("CREATE_ORDER_FAILED") ||
                                    res.lastKnownStatus.includes("BILL_PAY_FAILED") ||
                                    res.lastKnownStatus.includes("BILL_PAY_PENDING") ||
                                    res.lastKnownStatus.includes("BILL_PAY_PROCESSING")) {
                                    if (res.currentBillPayAmount != undefined &&
                                        res.currentBillPayAmount != null &&
                                        res.currentBillPayAmount > 0) {

                                        if (!consumerList.includes(res)) {
                                            if (res.optional != null) {
                                                const map = new Map(Object.entries(res.optional));
                                                var mapKeys = [...map.keys()];
                                                mapKeys.map(key => {
                                                    var optionMap = {
                                                        key: key,
                                                        value: map.get(key),
                                                        id: res.id
                                                    }
                                                    list.push(optionMap)
                                                    store.dispatch(setBillListKeys(list));
                                                })
                                            }


                                            if (res.currentBillPayAmount != undefined &&
                                                res.currentBillPayAmount != null &&
                                                res.currentBillPayAmount > 0
                                            ) {
                                                totalAmount = totalAmount + res.currentBillPayAmount;
                                                setTimeout(() => {
                                                    store.dispatch(setBillListTotalAmount(totalAmount));
                                                }, 300);
                                            }
                                            consumerList.push(res);
                                            setTimeout(() => {
                                                store.dispatch(setBillListConsumers(consumerList));
                                                store.dispatch(setBillListStartIndex(0))
                                                store.dispatch(setBillListEndIndex(5))
                                            }, 300);

                                        }

                                    }

                                }
                            }
                        }
                        else {

                            if (res.lastKnownStatus == due) {
                                if (res.lastKnownStatus != 'BILL_FETCH_FAILED' &&
                                    res.lastKnownStatus != 'NO_DUE_DATE_FOUND' &&
                                    res.lastKnownStatus != 'NO_FETCH_REQUIRED') {
                                    if (res.currentBillPayAmount != undefined &&
                                        res.currentBillPayAmount != null &&
                                        res.currentBillPayAmount > 0
                                    ) {
                                        if (!consumerList.includes(res)) {
                                            totalAmount = totalAmount + res.currentBillPayAmount;
                                            setTimeout(() => {
                                                store.dispatch(setBillListTotalAmount(totalAmount));
                                            }, 300);
                                            consumerList.push(res);
                                            store.dispatch(setBillListConsumers(consumerList));
                                            store.dispatch(setBillListStartIndex(0))
                                            store.dispatch(setBillListEndIndex(5))
                                            if (res.optional != null) {

                                                const map = new Map(Object.entries(res.optional));
                                                var mapKeys = [...map.keys()];
                                                mapKeys.map(key => {
                                                    var optionMap = {
                                                        key: key,
                                                        value: map.get(key),
                                                        id: res.id
                                                    }
                                                    list.push(optionMap)
                                                    store.dispatch(setBillListKeys(list));
                                                })
                                            }
                                        }

                                    } 
                                } else {
                                    if (!consumerList.includes(res)) {
                                        consumerList.push(res);
                                        store.dispatch(setBillListConsumers(consumerList));
                                        store.dispatch(setBillListStartIndex(0))
                                        store.dispatch(setBillListEndIndex(5))
                                        if (res.currentBillPayAmount != undefined &&
                                            res.currentBillPayAmount != null &&
                                            res.currentBillPayAmount > 0
                                        ) {
                                            totalAmount = totalAmount + res.currentBillPayAmount;
                                            setTimeout(() => {
                                                store.dispatch(setBillListTotalAmount(totalAmount));
                                            }, 300);
                                        }
                                    }

                                }
                             }else{
                               

                                //here
                                if(due=="MANUAL_BILLPAY_ENABLED"){
                                    if(res.billFetchFailedBeforeBillPay!=undefined &&
                                        res.billFetchFailedBeforeBillPay!=null &&
                                        res.billFetchFailedBeforeBillPay==true){
                                            if (!consumerList.includes(res)) {
                                                consumerList.push(res);
                                                store.dispatch(setBillListConsumers(consumerList));
                                                store.dispatch(setBillListStartIndex(0))
                                                store.dispatch(setBillListEndIndex(5))
                                                if (res.currentBillPayAmount != undefined &&
                                                    res.currentBillPayAmount != null &&
                                                    res.currentBillPayAmount > 0
                                                ) {
                                                    totalAmount = totalAmount + res.currentBillPayAmount;
                                                    setTimeout(() => {
                                                        store.dispatch(setBillListTotalAmount(totalAmount));
                                                    }, 300);
                                                }
                                            }
                                        }
                                }
                            }
                        }
                    } else {


                        if (res.fetchRequired == false) {
                            if (!consumerList.includes(res)) {
                                if (res.lastKnownStatus != 'CREATE_ORDER_SUCCESS' &&
                                    res.lastKnownStatus != 'BILL_PAY_PENDING' &&
                                    res.lastKnownStatus != 'BILL_PAY_PROCESSING') {
                                    if (res.optional != null) {
                                        const map = new Map(Object.entries(res.optional));
                                        var mapKeys = [...map.keys()];
                                        mapKeys.map(key => {
                                            var optionMap = {
                                                key: key,
                                                value: map.get(key),
                                                id: res.id
                                            }
                                            list.push(optionMap)
                                            store.dispatch(setBillListKeys(list));
                                        })
                                    }


                                    if (res.currentBillPayAmount != undefined &&
                                        res.currentBillPayAmount > 0
                                    ) {
                                        totalAmount = totalAmount + res.currentBillPayAmount;
                                        setTimeout(() => {
                                            store.dispatch(setBillListTotalAmount(totalAmount));
                                        }, 300);
                                    }
                                    consumerList.push(res);
                                    setTimeout(() => {
                                        store.dispatch(setBillListConsumers(consumerList));
                                        store.dispatch(setBillListStartIndex(0))
                                        store.dispatch(setBillListEndIndex(5))
                                    }, 300);


                                }
                            }

                        } else {
                            if (!consumerList.includes(res)) {
                                if (res.lastKnownStatus != 'CREATE_ORDER_SUCCESS' &&
                                    res.lastKnownStatus != 'BILL_PAY_PENDING' &&
                                    res.lastKnownStatus != 'BILL_PAY_PROCESSING' &&
                                    res.lastKnownStatus != 'BILL_PAY_SUCCESS' &&
                                    res.currentBillPayAmount != undefined &&
                                    res.currentBillPayAmount != null &&
                                    res.currentBillPayAmount > 0) {
                                    if (res.optional != null) {
                                        const map = new Map(Object.entries(res.optional));
                                        var mapKeys = [...map.keys()];
                                        mapKeys.map(key => {
                                            var optionMap = {
                                                key: key,
                                                value: map.get(key),
                                                id: res.id
                                            }
                                            list.push(optionMap)
                                            store.dispatch(setBillListKeys(list));
                                        })
                                    }


                                    if (res.currentBillPayAmount != undefined &&
                                        res.currentBillPayAmount != null &&
                                        res.currentBillPayAmount > 0
                                    ) {
                                        totalAmount = totalAmount + res.currentBillPayAmount;
                                        setTimeout(() => {
                                            store.dispatch(setBillListTotalAmount(totalAmount));
                                        }, 300);

                                    }

                                    

                                    consumerList.push(res);
                                    setTimeout(() => {
                                        store.dispatch(setBillListConsumers(consumerList));
                                        store.dispatch(setBillListStartIndex(0))
                                        store.dispatch(setBillListEndIndex(5))
                                    }, 300);

                                }
                            }

                        }

                    }
                })

            }

            this.setState({
                loading: 'completed'
            })

        }).catch(error => {
            this.setState({
                searchOn: true
            })

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }

            this.setState({
                loading: 'completed'
            })
        });
    }

    loadBills1(due) {
        store.dispatch(setBillListConsumers([]));
        store.dispatch(setBillListKeys([]));
        store.dispatch(setBillListTotalAmount(0));
        var totalActives = 0;
        var totalInactives = 0;

        this.setState({
            showFirstModal: false,
            loading: 'loading',
            searchOn: false
        })


        var url = '/api/v1/billpay/corp/consumer/get-list/';
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo,
            'role': this.props.clientRole
        }
        var value = (this.props.startDate != '' &&
            this.props.startDate != undefined &&
            this.props.startDate != null) ?
            '/' + this.props.startDate
            : '/all';

        var value1 = (this.props.endDate != '' &&
            this.props.endDate != undefined &&
            this.props.endDate != null) ?
            '/' + this.props.endDate
            : '/all'

        httpClient.get(url + this.props.agentInfo +
            value + value1,
            { headers }
        ).then((response) => {

            this.setState({
                searchOn: true
            })
            var list = [];
            var consumerList = [];
            var totalAmount = 0;

            if (response.data != null &&
                response.data != undefined &&
                response.data != "") {
                response.data.reverse().map(res => {
                    if (due != "") {
                        if (due == "no_due") {
                            if (res.lastBillFetch != null) {
                                if (res.lastKnownStatus.includes("BILL_PAY_SUCCESS")) {

                                    if (!consumerList.includes(res)) {
                                        if (res.optional != null) {
                                            const map = new Map(Object.entries(res.optional));
                                            var mapKeys = [...map.keys()];
                                            mapKeys.map(key => {
                                                var optionMap = {
                                                    key: key,
                                                    value: map.get(key),
                                                    id: res.id
                                                }
                                                list.push(optionMap)
                                                store.dispatch(setBillListKeys(list));
                                            })
                                        }


                                        if (res.currentBillPayAmount != undefined &&
                                            res.currentBillPayAmount > 0
                                        ) {
                                            totalAmount = totalAmount + res.currentBillPayAmount;
                                            setTimeout(() => {
                                                store.dispatch(setBillListTotalAmount(totalAmount));
                                            }, 300);

                                        }
                                        consumerList.push(res);
                                        setTimeout(() => {
                                            store.dispatch(setBillListConsumers(consumerList));
                                            store.dispatch(setBillListStartIndex(0))
                                            store.dispatch(setBillListEndIndex(5))
                                        }, 300);

                                    }

                                }
                            }
                        }
                        else if (due == "payment_due") {
                            if (res.lastBillFetch != null) {
                                if (res.lastKnownStatus.includes("BILL_FETCH_SUCCESS") ||
                                    res.lastKnownStatus.includes("CREATE_ORDER_SUCCESS") ||
                                    res.lastKnownStatus.includes("CREATE_ORDER_FAILED") ||
                                    res.lastKnownStatus.includes("BILL_PAY_FAILED") ||
                                    res.lastKnownStatus.includes("BILL_PAY_PENDING") ||
                                    res.lastKnownStatus.includes("BILL_PAY_PROCESSING")) {
                                    if (res.currentBillPayAmount != undefined &&
                                        res.currentBillPayAmount != null &&
                                        res.currentBillPayAmount > 0) {

                                        if (!consumerList.includes(res)) {
                                            if (res.optional != null) {
                                                const map = new Map(Object.entries(res.optional));
                                                var mapKeys = [...map.keys()];
                                                mapKeys.map(key => {
                                                    var optionMap = {
                                                        key: key,
                                                        value: map.get(key),
                                                        id: res.id
                                                    }
                                                    list.push(optionMap)
                                                    store.dispatch(setBillListKeys(list));
                                                })
                                            }


                                            if (res.currentBillPayAmount != undefined &&
                                                res.currentBillPayAmount != null &&
                                                res.currentBillPayAmount > 0
                                            ) {
                                                totalAmount = totalAmount + res.currentBillPayAmount;
                                                setTimeout(() => {
                                                    store.dispatch(setBillListTotalAmount(totalAmount));
                                                }, 300);
                                            }
                                            consumerList.push(res);
                                            setTimeout(() => {
                                                store.dispatch(setBillListConsumers(consumerList));
                                                store.dispatch(setBillListStartIndex(0))
                                                store.dispatch(setBillListEndIndex(5))
                                            }, 300);

                                        }

                                    }

                                }
                            }
                        }
                        else {

                            if (res.lastKnownStatus == due) {
                                if (res.lastKnownStatus != 'BILL_FETCH_FAILED' &&
                                    res.lastKnownStatus != 'NO_DUE_DATE_FOUND' &&
                                    res.lastKnownStatus != 'NO_FETCH_REQUIRED') {
                                    if (res.currentBillPayAmount != undefined &&
                                        res.currentBillPayAmount != null &&
                                        res.currentBillPayAmount > 0
                                    ) {
                                        if (!consumerList.includes(res)) {
                                            totalAmount = totalAmount + res.currentBillPayAmount;
                                            setTimeout(() => {
                                                store.dispatch(setBillListTotalAmount(totalAmount));
                                            }, 300);
                                            consumerList.push(res);
                                            store.dispatch(setBillListConsumers(consumerList));
                                            store.dispatch(setBillListStartIndex(0))
                                            store.dispatch(setBillListEndIndex(5))
                                            if (res.optional != null) {

                                                const map = new Map(Object.entries(res.optional));
                                                var mapKeys = [...map.keys()];
                                                mapKeys.map(key => {
                                                    var optionMap = {
                                                        key: key,
                                                        value: map.get(key),
                                                        id: res.id
                                                    }
                                                    list.push(optionMap)
                                                    store.dispatch(setBillListKeys(list));
                                                })
                                            }
                                        }

                                    } else {

                                    }
                                } else {
                                    if (!consumerList.includes(res)) {
                                        consumerList.push(res);
                                        store.dispatch(setBillListConsumers(consumerList));
                                        store.dispatch(setBillListStartIndex(0))
                                        store.dispatch(setBillListEndIndex(5))
                                        if (res.currentBillPayAmount != undefined &&
                                            res.currentBillPayAmount != null &&
                                            res.currentBillPayAmount > 0
                                        ) {
                                            totalAmount = totalAmount + res.currentBillPayAmount;
                                            setTimeout(() => {
                                                store.dispatch(setBillListTotalAmount(totalAmount));
                                            }, 300);
                                        }
                                    }

                                }
                            }
                        }
                    } else {


                        if (res.fetchRequired == false) {
                            if (!consumerList.includes(res)) {
                                if (res.lastKnownStatus != 'CREATE_ORDER_SUCCESS' &&
                                    res.lastKnownStatus != 'BILL_PAY_PENDING' &&
                                    res.lastKnownStatus != 'BILL_PAY_PROCESSING') {
                                    if (res.optional != null) {
                                        const map = new Map(Object.entries(res.optional));
                                        var mapKeys = [...map.keys()];
                                        mapKeys.map(key => {
                                            var optionMap = {
                                                key: key,
                                                value: map.get(key),
                                                id: res.id
                                            }
                                            list.push(optionMap)
                                            store.dispatch(setBillListKeys(list));
                                        })
                                    }


                                    if (res.currentBillPayAmount != undefined &&
                                        res.currentBillPayAmount > 0
                                    ) {
                                        totalAmount = totalAmount + res.currentBillPayAmount;
                                        setTimeout(() => {
                                            store.dispatch(setBillListTotalAmount(totalAmount));
                                        }, 300);
                                    }
                                    consumerList.push(res);
                                    setTimeout(() => {
                                        store.dispatch(setBillListConsumers(consumerList));
                                        store.dispatch(setBillListStartIndex(0))
                                        store.dispatch(setBillListEndIndex(5));
                                        store.dispatch(selectedConsumerList(this.state.selectedConsumers))
                                    }, 300);


                                }
                            }

                        } else {
                            if (!consumerList.includes(res)) {
                                if (res.lastKnownStatus != 'CREATE_ORDER_SUCCESS' &&
                                    res.lastKnownStatus != 'BILL_PAY_PENDING' &&
                                    res.lastKnownStatus != 'BILL_PAY_PROCESSING' &&
                                    res.lastKnownStatus != 'BILL_PAY_SUCCESS' &&
                                    res.currentBillPayAmount != undefined &&
                                    res.currentBillPayAmount != null &&
                                    res.currentBillPayAmount > 0) {
                                    if (res.optional != null) {
                                        const map = new Map(Object.entries(res.optional));
                                        var mapKeys = [...map.keys()];
                                        mapKeys.map(key => {
                                            var optionMap = {
                                                key: key,
                                                value: map.get(key),
                                                id: res.id
                                            }
                                            list.push(optionMap)
                                            store.dispatch(setBillListKeys(list));
                                        })
                                    }


                                    if (res.currentBillPayAmount != undefined &&
                                        res.currentBillPayAmount != null &&
                                        res.currentBillPayAmount > 0
                                    ) {
                                        totalAmount = totalAmount + res.currentBillPayAmount;
                                        setTimeout(() => {
                                            store.dispatch(setBillListTotalAmount(totalAmount));
                                        }, 300);

                                    }
                                    consumerList.push(res);
                                    setTimeout(() => {
                                        store.dispatch(setBillListConsumers(consumerList));
                                        store.dispatch(setBillListStartIndex(0));
                                        store.dispatch(setBillListEndIndex(5));
                                        store.dispatch(selectedConsumerList(this.state.selectedConsumers))
                                    }, 300);

                                }
                            }

                        }

                    }
                })

            }

            this.setState({
                loading: 'completed'
            })

        }).catch(error => {
            this.setState({
                searchOn: true
            })

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }

            this.setState({
                loading: 'completed'
            })
        });
    }

    componentDidMount() {
        store.dispatch(setSelectedAmount(0))
        store.dispatch(setBatch(''))
        this.setState({
            payErr: '',
            searchOn: true
        })
        setInterval(() => {
            var totalAmount = 0;
            var len = this.props.selectedConsumers.length;

            if (len > 0) {

                this.props.selectedConsumers.map(consumer => {
                    if (consumer.currentBillPayAmount != undefined &&
                        consumer.currentBillPayAmount != null &&
                        consumer.currentBillPayAmount > 0
                    ) {
                        var amnt = consumer.currentBillPayAmount;
                        totalAmount = totalAmount + amnt;

                    }
                })

            }


            this.setState({
                len: len,
                selectedConsumers: this.props.selectedConsumers,
                selectedAmount: totalAmount,

            })
        }, 100);
    }
    componentWillUnmount() {
    }


    statusSelect = (event) => {
        event.preventDefault();

        if (event.target.value == "Select") {
            // alert("Please select a value")
        }
        if (event.target.value == "no_due") {
            this.loadBills("no_due");
        }
        if (event.target.value == "INITIATED") {
            this.loadBills("INITIATED");
        }
        if (event.target.value == "NO_FETCH_REQUIRED") {
            this.loadBills("NO_FETCH_REQUIRED");
        }
        if (event.target.value == "BILL_FETCH_FAILED") {
            this.loadBills("BILL_FETCH_FAILED");
        }
        if (event.target.value == "MANUAL_BILLPAY_ENABLED") {
            this.loadBills("MANUAL_BILLPAY_ENABLED");
        }

        if (event.target.value == "BILL_FETCH_SUCCESS") {
            this.loadBills("BILL_FETCH_SUCCESS");
        }
        if (event.target.value == "NO_DUE_DATE_FOUND") {
            this.loadBills("NO_DUE_DATE_FOUND");
        }
        if (event.target.value == "BILL_PAY_PENDING") {
            this.loadBills("BILL_PAY_PENDING");
        }
        if (event.target.value == "BILL_PAY_FAILED") {
            this.loadBills("BILL_PAY_FAILED");
        }
        if (event.target.value == "BILL_PAY_SUCCESS") {
            this.loadBills("BILL_PAY_SUCCESS");
        }
        if (event.target.value == "BILL_PAY_PROCESSING") {
            this.loadBills("BILL_PAY_PROCESSING");
        }
        if (event.target.value == "BILL_PAY_PROCESSING") {
            this.loadBills("BILL_PAY_PROCESSING");
        }
        if (event.target.value == "CREATE_ORDER_SUCCESS") {
            this.loadBills("CREATE_ORDER_SUCCESS");
        }
        if (event.target.value == "CREATE_ORDER_FAILED") {
            this.loadBills("CREATE_ORDER_FAILED");
        }

        if (event.target.value == "payment_due") {
            this.loadBills("payment_due");
        }


    }



    clear = (event) => {
        event.preventDefault();
        setTimeout(() => {
            this.loadBills("");
            // history.push('/bill-list');
            // history.go();
        }, 200);
    }

    removeBiller = (event, consumer) => {
        event.preventDefault();
        var cnsList = [];
        var amount = 0;
        const index = this.state.selectedConsumers.indexOf(consumer);
        this.state.selectedConsumers.splice(index, 1);
        const index1 = this.state.noFetchBillers.indexOf(consumer);
        this.state.noFetchBillers.splice(index1, 1);
        this.state.selectedConsumers.map(cnsumer => {
            if (cnsumer.id == consumer.id) {

            } else {
                // cnsList.push(cnsumer);
                amount = amount + cnsumer.currentBillPayAmount;
            }
        })

        setTimeout(() => {
            store.dispatch(selectedConsumerList(this.state.selectedConsumers));
            store.dispatch(setSelectedAmount(amount));

        }, 200);
    }

    closeFirstModal = (event) => {
        event.preventDefault();
        var cnsList = [];
        var amount = 0;
        this.state.selectedConsumers.map(cnsumer => {
            if (cnsumer.fetchRequired == false) {
                cnsumer.currentBillPayAmount = this.state.noFetchMap.get(cnsumer.id);
                const index = this.state.selectedConsumers.indexOf(cnsumer);
                this.state.selectedConsumers.splice(index, 1);
                // cnsumer.currentBillPayAmount = parseInt('0');
            } else {
                cnsList.push(cnsumer);
                amount = amount + cnsumer.currentBillPayAmount;
            }
        })

        setTimeout(() => {
            store.dispatch(selectedConsumerList(cnsList));
            store.dispatch(setSelectedAmount(amount));
            this.setState({
                showFirstModal: false
            })

            this.proceed2();


        }, 200);

    }

    enterAmount = (event, consumer) => {
        event.preventDefault();


        this.billMap.set(consumer.id, parseInt(event.target.value))

    }

    proceed = (event) => {

        event.preventDefault();
        this.setState({
            payErr: ''
        })

        var amount = this.state.selectedAmount;

        var sConsumer = this.state.selectedConsumers;
        var consumerList = [];
        sConsumer.map(consumer => {
            if (consumer.fetchRequired == false) {

                if (this.billMap.get(consumer.id) != undefined &&
                    this.billMap.get(consumer.id) > 0) {
                    amount = amount + this.billMap.get(consumer.id);
                    consumer.currentBillPayAmount = this.billMap.get(consumer.id)
                    consumerList.push(consumer);
                } else {
                    amount = amount - consumer.currentBillPayAmount;

                }
            } else {
                if (consumer.lastKnownStatus == 'BILL_FETCH_FAILED') {
                    if (this.billMap.get(consumer.id) != undefined &&
                        this.billMap.get(consumer.id) > 0) {
                        amount = amount + this.billMap.get(consumer.id);
                        consumer.currentBillPayAmount = this.billMap.get(consumer.id)
                        consumerList.push(consumer);
                    } else {
                        amount = amount - consumer.currentBillPayAmount;
                    }
                } else {
                    if (consumer.currentBillPayAmount > 0) {
                        consumerList.push(consumer);
                    }
                }

            }
        })


        if (amount == 0) {
            this.setState({
                payErr: "selected amount is 0"
            })
            swal({
                title: "Unable to proceed",
                text: 'Selected Amount is 0',
                icon: "error",
                button: true,
                dangerMode: true,
            }).then(() => {
                history.push('/bill-list');
                history.go();
            });
        } else {
            if (amount <= this.props.retailerBalanceValue) {
                setTimeout(() => {
                    store.dispatch(selectedConsumerList(consumerList))
                    store.dispatch(setSelectedAmount(amount))
                    history.push('/payment');
                    history.go();
                    // var goTopayment = document.getElementById('goTopayment');
                    // if (goTopayment != null) {
                    //     goTopayment.click();
                    // } else {
                    //     history.push('/payment');
                    //     history.go();
                    // }
                }, 400);
            } else {
                this.setState({
                    payErr: "Balance is lower than selected Amount"
                })
                swal({
                    title: "Unable to proceed",
                    text: 'Balance is lower than selected amount',
                    icon: "error",
                    button: true,
                    dangerMode: true,
                }).then(() => {
                    this.loadBills("");
                    // history.push('/bill-list');
                    // history.go();
                });

            }
        }


    }
    proceed2 = () => {

        this.setState({
            payErr: ''
        })

        var amount = this.state.selectedAmount;

        var sConsumer = this.state.selectedConsumers;
        var consumerList = [];
        sConsumer.map(consumer => {
            if (consumer.fetchRequired == false) {

                if (this.billMap.get(consumer.id) != undefined &&
                    this.billMap.get(consumer.id) > 0) {
                    amount = amount + this.billMap.get(consumer.id);
                    consumer.currentBillPayAmount = this.billMap.get(consumer.id)
                    consumerList.push(consumer);
                } else {
                    amount = amount - consumer.currentBillPayAmount;

                }
            } else {
                if (consumer.lastKnownStatus == 'BILL_FETCH_FAILED') {
                    if (this.billMap.get(consumer.id) != undefined &&
                        this.billMap.get(consumer.id) > 0) {
                        amount = amount + this.billMap.get(consumer.id);
                        consumer.currentBillPayAmount = this.billMap.get(consumer.id)
                        consumerList.push(consumer);
                    } else {
                        amount = amount - consumer.currentBillPayAmount;
                    }
                } else {
                    if (consumer.currentBillPayAmount > 0) {
                        consumerList.push(consumer);
                    }
                }

            }
        })

        if (amount == 0) {
            this.setState({
                payErr: "selected amount is 0"
            })
            swal({
                title: "Unable to proceed",
                text: 'Selected Amount is 0',
                icon: "error",
                button: true,
                dangerMode: true,
            }).then(() => {
                history.push('/bill-list');
                history.go();
            });
        } else {
            if (amount <= this.props.retailerBalanceValue) {
                setTimeout(() => {
                    store.dispatch(selectedConsumerList(consumerList))
                    store.dispatch(setSelectedAmount(amount))
                    history.push('/payment');
                    history.go();
                    // var goTopayment = document.getElementById('goTopayment');
                    // if (goTopayment != null) {
                    //     goTopayment.click();
                    // } else {
                    //     history.push('/payment');
                    //     history.go();
                    // }
                }, 400);
            } else {
                this.setState({
                    payErr: "Balance is lower than selected Amount"
                })
                swal({
                    title: "Unable to proceed",
                    text: 'Balance is lower than selected amount',
                    icon: "error",
                    button: true,
                    dangerMode: true,
                }).then(() => {
                    this.loadBills("");
                    // history.push('/bill-list');
                    // history.go();
                });

            }
        }


    }
    proceed3 = (amount, sConsumer) => {

        this.setState({
            payErr: ''
        })

        var consumerList = [];
        sConsumer.map(consumer => {
            if (consumer.fetchRequired == false) {

                if (this.billMap.get(consumer.id) != undefined &&
                    this.billMap.get(consumer.id) > 0) {
                    amount = amount + this.billMap.get(consumer.id);
                    consumer.currentBillPayAmount = this.billMap.get(consumer.id)
                    consumerList.push(consumer);
                } else {
                    amount = amount - consumer.currentBillPayAmount;

                }
            } else {
                if (consumer.lastKnownStatus == 'BILL_FETCH_FAILED') {
                    if (this.billMap.get(consumer.id) != undefined &&
                        this.billMap.get(consumer.id) > 0) {
                        amount = amount + this.billMap.get(consumer.id);
                        consumer.currentBillPayAmount = this.billMap.get(consumer.id)
                        consumerList.push(consumer);
                    } else {
                        amount = amount - consumer.currentBillPayAmount;
                    }
                } else {
                    if (consumer.currentBillPayAmount > 0) {
                        consumerList.push(consumer);
                    }
                }

            }
        })

        if (amount == 0) {
            this.setState({
                payErr: "selected amount is 0"
            })
            swal({
                title: "Unable to proceed",
                text: 'Selected Amount is 0',
                icon: "error",
                button: true,
                dangerMode: true,
            }).then(() => {
                history.push('/bill-list');
                history.go();
            });
        } else {

            if (amount <= this.props.retailerBalanceValue) {
                setTimeout(() => {
                    store.dispatch(selectedConsumerList(consumerList))
                    store.dispatch(setSelectedAmount(amount))

                    history.push('/payment');
                    history.go();
                    // var goTopayment = document.getElementById('goTopayment');
                    // if (goTopayment != null) {
                    //     goTopayment.click();
                    // } else {
                    //     history.push('/payment');
                    //     history.go();
                    // }
                }, 400);
            } else {
                this.setState({
                    payErr: "Balance is lower than selected Amount"
                })
                swal({
                    title: "Unable to proceed",
                    text: 'Balance is lower than selected amount',
                    icon: "error",
                    button: true,
                    dangerMode: true,

                }).then(() => {
                    this.loadBills("");
                    // history.push('/bill-list');
                    // history.go();
                });

            }
        }


    }

    selectLastEnteredAmount = (event, consumer) => {
        event.preventDefault();
        this.billMap.set(consumer.id, this.state.noFetchMap.get(consumer.id))
    }

    searchConsumer = (event) => {
        event.preventDefault();

        var list = [];
        var amount = 0;
        this.props.billListConsumers.map(consumer => {
            if (JSON.stringify(consumer).includes(this.state.consumerNoVal)) {
                list.push(consumer);
                if (consumer.currentBillPayAmount != undefined &&
                    consumer.currentBillPayAmount != null &&
                    consumer.currentBillPayAmount > 0) {
                    amount = amount + consumer.currentBillPayAmount;
                }
            }
        })
        setTimeout(() => {
            this.setState({
                searchOn: false
            })
            store.dispatch(setBillListConsumers(list))
            store.dispatch(setBillListTotalAmount(amount))
            store.dispatch(setBillListStartIndex(0))
            // store.dispatch(setBillListEndIndex(list.length))
            store.dispatch(setBillListEndIndex(5))

        }, 300);
    }

    enteConsumerNo = (event) => {
        event.preventDefault();
        this.setState({
            consumerNoVal: event.target.value
        })
    }

    render() {

        return (
            <div>

                <div class="dashhead">
                    <h3>Bill List</h3>
                    <div class="backbtn">
                        <Link to="/dashboard">
                            <button type="button" class="back"
                            >Back</button>
                        </Link>
                    </div>
                    <div class="headsrch">
                        <div class="input-group">

                            <input type="text" class="form-control" placeholder="Search ..."
                                aria-describedby="srchbtn" onChange={this.enteConsumerNo}
                                value={this.state.consumerNoVal}
                                disabled={this.state.searchOn == false ? true : false} />
                            <button class="btn" type="button" id="srchbtn" onClick={this.searchConsumer}
                                disabled={this.state.searchOn == false ? true : false}>search</button>
                            <button type="btn" class="lbbtn" id="btnClear"
                                onClick={this.clear}
                            >Clear</button>
                        </div>
                    </div>
                </div>
                <div class="totalbill">

                    <div class="row">


                        <button type="button" class="print" data-bs-toggle="modal"
                            id="modalPrint"
                            data-bs-target="#print" hidden={true}></button>
                        {/* {this.state.showFirstModal == true &&
                            this.state.noFetchBillers.length > 0 &&
                            <button type="button" class="print" data-bs-toggle="modal"
                            data-bs-target="#print" hidden={true}></button>
                        } */}

                        <div class="col-12 col-sm-6 col-md-5 col-lg-5">
                            <Link to='/payment'>
                                <button id="goTopayment"
                                    hidden={true}></button>
                            </Link>
                            <div class="ttlbilvew">
                                <p>Bill Count</p>
                                <h5>{this.props.billListConsumers.length}</h5>
                            </div>

                            <div class="ttlbilvew rtxt">
                                <p>Total Bill Amount</p>
                                <h5>₹ {(this.props.billListAmount != null &&
                                    this.props.billListAmount != undefined) ?
                                    this.props.billListAmount.toLocaleString("en-US") : 0}</h5>
                            </div>
                        </div>



                        {this.state.selectedConsumers.length > 0 &&
                            <div class="col-12 col-sm-6 col-md-5 col-lg-5" id="slctcnt"
                            // style="display:none;"
                            >
                                <div class="ttlbilvew" >
                                    <p>Selected Bill Count</p>
                                    <h5>{this.state.selectedConsumers.length}</h5>
                                </div>

                                <div class="ttlbilvew rtxt">
                                    <p>Payable Bill Amount</p>
                                    <h5>₹ {this.state.selectedAmount}</h5>
                                </div>
                            </div>
                        }
                        {(this.state.showFirstModal == true &&
                            this.state.noFetchBillers.length > 0) ?
                            <div class="col-12 col-sm-6 col-md-2">
                                <div class="ttlbilbtn">
                                    <button class="dbbtn"
                                        disabled
                                        title={'Disabled'}
                                    >Pay Now</button>


                                    <button class="dbbtn" disabled
                                        title={'Disabled'}
                                    >Pay All</button>
                                </div>

                            </div> :
                            <div class="col-12 col-sm-6 col-md-2">
                                <div class="ttlbilbtn">
                                    <button class="dbbtn" onClick={this.pay}
                                        disabled={this.state.selectedConsumers.length > 0 ? false : true}
                                        title={this.state.selectedConsumers.length > 0 ? 'Pay Now' : 'Disabled'}
                                    >Pay Now</button>


                                    <button class="dbbtn" onClick={this.payAll}
                                        disabled={this.props.billListConsumers.length > 0 ? false : true}
                                        title={this.props.billListConsumers.length > 0 ? 'Pay All' : 'Disabled'}
                                    >Pay All</button>
                                </div>

                            </div>


                        }

                        {this.state.selectedConsumers.length == 0 &&
                            <div class="col-12 col-sm-6 col-md-5 col-lg-5">
                                {this.props.billListConsumers != undefined &&
                                    this.props.billListConsumers.length > 0 &&
                                    this.props.totalDueList != undefined &&
                                    this.props.totalDueList.length > 0 &&
                                    <CSVLink
                                        class="lbbtn1"
                                        data={this.props.totalDueList}
                                        asyncOnClick={true}
                                        filename={"Due_List" + ".csv"}
                                    >Download </CSVLink>

                                }
                                <div class="dropdown filbox1">


                                    <button type="button" class="dropdown-toggle fltrbtn" data-bs-auto-close="outside" id="fltrid" data-bs-toggle="dropdown" aria-expanded="false" aria-haspopup="true"></button>

                                    <div class="dropdown-menu dropdown-menu-end" aria-labelledby="fltrid">
                                        {this.state.loading != 'loading' &&
                                            <div class="filters">
                                                <label for="status">Status:</label>
                                                <select class="form-select" id="status"
                                                    onChange={this.statusSelect} size={12}>
                                                    {this.state.statusList.map(status => (
                                                        <option value={status.value}
                                                        >{status.label}</option>
                                                    ))}

                                                </select>
                                            </div>
                                        }
                                        <div class="filters">
                                            <button type="button" class="clear" id="btnClear" onClick={this.clear}
                                                disabled={this.state.loading == 'loading' ? true : false}>Clear</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                </div >
                <div class="modal fade" id="print" data-bs-backdrop="static"
                    data-bs-keyboard="false" tabindex="-1">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header modhead">
                                <h5 class="modal-title">Please enter amount for selected billers</h5>
                                <button type="button" class="btn-close" onClick={this.closeFirstModal}
                                    data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>

                            <div class="modal-body">
                                {/* <div class="ttlbilvew rtxt"> */}
                                <div><i>(To process billpay below billers need amount to be added manually.Close window to skip/not include these billers)</i></div>
                                {this.state.noFetchBillers.map((consumer, index) => (
                                    <div>
                                        {this.state.noFetchBillers.length > 1 &&
                                            <li>Biller No: {index + 1}. <button type="button" class="btn lbbtn" onClick={e => this.removeBiller(e, consumer)}>Remove Biller.</button></li>
                                        }
                                        <li>{'Biller Name: ' + consumer.billerName}</li>
                                        <li>{'Category: ' + consumer.billerCategory}</li>
                                        <li><i>{'Consumer parameter: ' + Object.entries(consumer.optional).map(([key, value]) => `${key}=${value}`).join('&')}</i></li>
                                        {consumer.lastKnownStatus !== 'BILL_FETCH_FAILED' &&
                                            <li><i>Last Order Amount:{this.state.noFetchMap.get(consumer.id)}</i></li>
                                        }


                                        {(consumer.lastKnownStatus !== 'BILL_FETCH_FAILED' &&
                                            consumer.currentBillPayAmount != undefined &&
                                            consumer.currentBillPayAmount != null &&
                                            consumer.currentBillPayAmount != "") &&
                                            <li>Select the last entered Amount:  <button type="button"
                                                class="btn dbbtn" onClick={e => this.selectLastEnteredAmount(e, consumer)}>Select Last Amount</button>
                                            </li>
                                        }


                                        <div class="col-12 col-sm-6 col-md-5 col-lg-5">{consumer.lastKnownStatus == 'BILL_FETCH_FAILED' ? 'Enter Amount' : 'Enter a different amount'}
                                            <input type="number" class="form-control" id="amount"
                                                placeholder="Amount" onChange={e => this.enterAmount(e, consumer)}
                                                min="0" max="999999"
                                                required />

                                        </div>
                                        {/* <ul> </ul> */}
                                        <ul> </ul>

                                    </div>

                                ))}

                                {/* </div> */}

                            </div>
                            <div class="modal-footer">
                                <button type="button" id="proceedModal" class="btn dbbtn" onClick={this.proceed} data-bs-dismiss="modal">Proceed</button>
                                <button type="button" class="btn dbbtn" onClick={this.clear} data-bs-dismiss="modal">Reset</button>
                            </div>
                            {/* <ul> </ul>
                            <ul></ul> */}
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone, selectedConsumers, deviceInfo, clientRole,
            agentInfo, billListConsumers, billListAmount, billListKeys,
            startDate, endDate, token, retailerBalanceValue, totalDueList } }
) => ({
    errorMessage, loginErrorMessage, phone, selectedConsumers, deviceInfo,
    clientRole, agentInfo, billListConsumers, billListAmount, billListKeys,
    startDate, endDate, token, retailerBalanceValue, totalDueList
});

export default connect(mapStateToProps, null)(BillListTotalComponent);
